import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageTitle } from '../appInfo';
import { api } from '../api/api';
import { cliTarget, postToCli } from '../utils/cliLogin';

/**
 * **synchro-client にブラウザのログインを渡す**（`synchro-client login --web`。Issue #877）。
 *
 * synchro-client が PC の中だけの口（127.0.0.1:<port>）を開いて、この画面を `?port=&state=` 付きで開く。
 * ログインしていなければ AuthGuard がログインの画面へ送り、戻ってくる。「許可する」を押すと本番に
 * この PC 用の新しいトークンを出してもらい（`IssueCliToken`。この画面のトークンは使い回さない）、
 * その口へフォームで POST する（URL に載せない＝ブラウザの履歴に残さない）。state は synchro-client が確かめる。
 */
export default function CliLogin() {
  usePageTitle('synchro-client にログイン');
  const { search } = useLocation();
  const target = cliTarget(search);
  const [state, setState] = useState('ask');   // ask | sending | error | cancelled
  const [error, setError] = useState('');

  if (!target) {
    return <div className="page"><h2>synchro-client にログイン</h2><p className="error">この画面は synchro-client の <code>login --web</code> から開きます（口か印がおかしい）。</p></div>;
  }

  const allow = async () => {
    setState('sending');
    try {
      const res = await api.project('IssueCliToken');
      if (!res?.token) throw new Error(res?.error || 'トークンを出せませんでした');
      postToCli(target, { state: target.state, token: res.token, base: window.location.origin, username: res.username || '' });
    } catch (e) {
      setError(e.message || String(e));
      setState('error');
    }
  };

  return (
    <div className="page" style={{ maxWidth: 560 }}>
      <h2>synchro-client にログイン</h2>
      {state === 'cancelled' ? (
        <p>やめました。このタブは閉じてかまいません。</p>
      ) : (
        <>
          <p>この PC の synchro-client（<code>127.0.0.1:{target.port}</code>）に、今のログインを渡しますか？</p>
          <p style={{ color: '#888', fontSize: '0.85rem' }}>
            synchro-client 用に新しいトークンを出して、この PC の中だけに渡します。自分で <code>synchro-client login --web</code> を流したときだけ許可してください。
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary" disabled={state === 'sending'} onClick={allow}>許可する</button>
            <button className="btn btn-secondary" disabled={state === 'sending'} onClick={() => setState('cancelled')}>やめる</button>
          </div>
          {state === 'error' && <p className="error">渡せませんでした: {error}</p>}
        </>
      )}
    </div>
  );
}
